import { Box, Flex, Heading, Image } from "@chakra-ui/react";
import React from "react";
import stats from "../Images/stats.png";
import "./stats.css";

const Stats = () => {
  return (
    <>
      <Box
        w={"92%"}
        m={"auto"}
        mt={"50px"}
        // border={"solid black"}
        p={"10"}
        className="stats-box"
      >
        <Heading
          as={"h1"}
          size={"xl"}
          m={"auto"}
          bgColor={"#89CFF0"}
          p={"4"}
          borderRadius={"10px"}
        >
          Days I've Code
        </Heading>
        <Box mt={"10"}>
          <Image
            src={stats}
            className="statimage"
            m={"auto"}
            borderRadius={"15"}
          ></Image>
        </Box>
        <Flex m={"auto"} mt={"50px"} justifyContent={"space-evenly"}>
          <Image
            w={"30%"}
            className="statimage"
            id="github-stats-card"
            src="https://github-readme-stats.vercel.app/api?username=aslammmahetar&theme=vue-dark&show_icons=true&hide_border=true&count_private=true"
          ></Image>
          <Image
            w={"30%"}
            className="statimage"
            id="github-streak-stats"
            src="https://github-readme-streak-stats.herokuapp.com/?user=aslammmahetar&theme=vue-dark&hide_border=true"
          ></Image>
        </Flex>
        <Box mt={"50px"}>
          <Image
            w={"30%"}
            className="statimage"
            m={"auto"}
            id="github-top-langs"
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=aslammmahetar&theme=vue-dark&show_icons=true&hide_border=true&layout=compact"
          ></Image>
        </Box>
      </Box>
    </>
  );
};

export default Stats;
